var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "SynastryInterpret" },
    [
      _vm._m(0),
      _c(
        "div",
        { staticClass: "SynastryInterpret__content" },
        _vm._l(_vm.interpretations, function(item, index) {
          return _c("SynastryInterpretCard", {
            key: index,
            attrs: { interpretData: item }
          })
        }),
        1
      ),
      _c("transition", { attrs: { name: "fade" } }, [
        _c(
          "div",
          {
            directives: [
              {
                name: "show",
                rawName: "v-show",
                value: _vm.interpretTabNotice,
                expression: "interpretTabNotice"
              }
            ],
            staticClass: "SynastryInterpret__notice"
          },
          [
            _c("img", {
              attrs: { src: require("@/assets/上下滑動.svg"), alt: "" }
            }),
            _c("span", { staticClass: "mt-3" }, [_vm._v("上下滑动浏览解读")])
          ]
        )
      ])
    ],
    1
  )
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "SynastryInterpret__main" }, [
      _c("div", { staticClass: "SynastryInterpret__main__line" }),
      _c("div", { staticClass: "SynastryInterpret__main__info" }, [
        _c("img", {
          attrs: { src: require("@/assets/共時曆/bigStart.svg"), alt: "" }
        }),
        _c("span", [_vm._v("星象解读")])
      ]),
      _c("div", { staticClass: "SynastryInterpret__main__line" })
    ])
  }
]
render._withStripped = true

export { render, staticRenderFns }